import {inject, Injectable} from '@angular/core';
import {StateManagerService} from '@core/services';
import {StateManager} from '@core/types';
import {CONFIG} from '@core/utils';
import {CompliantsClientSession} from '@compliants-client/types';
import {STORAGE_KEYS} from '@compliants-client/config';

@Injectable({
  providedIn: 'root'
})
export class CompliantsClientStateService {
  private stateManager = inject(StateManagerService);

  private state: StateManager<CompliantsClientSession> = this.stateManager.createState<CompliantsClientSession>({
    storage: 'sessionStorage',
    key: STORAGE_KEYS.CLIENT_SESSION,
    storageOptions: {
      ttl: CONFIG.TTL_APP,
      prefix: 'client',
      encrypt: true
    },
    initialValue: {
      token: null,
      clientUserId: null,
      compliantId: null,
      channelId: null
    }
  });

  session = this.state.value;
  token = this.state.computed(state => state.token);
  compliantId = this.state.computed(state => state.compliantId);
  clientUserId = this.state.computed(state => state.clientUserId);
  channelId = this.state.computed(state => state.channelId);

  async initialize() {
    await this.state.loadFromStorage();
  }

  setSession(session: CompliantsClientSession) {
    this.state.set(session);
  }

  clearSession() {
    this.state.clearStorage();
    this.state.set({
      token: null,
      clientUserId: null,
      compliantId: null,
      channelId: null
    });
  }
}
